module.exports = __webpack_public_path__ + "static/media/talk_now_disable.894e2126.png";